import { RouteObject, useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';



import AppRoutes from 'containers/app-container/routes/AppRoute';

export default function Routes() {
  
  return useRoutes(
    [
      
      // !isLoggedIn && AuthenticationRoutes,
      // ...RoutesAthenticateds,
      // ...PublicRoutes,
      AppRoutes
    ].filter(Boolean) as RouteObject[]
  );
}
